export default "__VITE_ASSET__c7377249__"